export const formatter = (values) => {
  const formatted = {
    gift_table: {
      thanks_message: {
        type_id: values.messageType,
        message: values.thanksMessage,
      },
      showing_purchased_products: values.keepShowingProducts,
    },
  };

  if (values.address) {
    formatted.address_id = values.address?.id;
  }

  return formatted;
};
